<div class="form-modal" style="width: 1050px" *ngIf="form">
  <h1 mat-dialog-title>{{'DISTRIBUTION'|translate}}</h1>
  <form [formGroup]="form" class="form-horizontal" (keydown.enter)="$event.preventDefault()">
    <div mat-dialog-content>
      <div class="col-lg-12 col-md-12 col-sm-12 no-padding">
        <div *ngIf="form != null" class="table table-bordered display table-actions" cellspacing="0">
          <table>
            <thead>
              <tr>
                <th width="17%">
                  <strong>{{'TYPE'|translate}}</strong>
                </th>
                <th width="35%">
                  <strong>{{'DIVISIONKEY_COSTCENTER'|translate}}</strong>
                </th>
                <th width="8%">
                  <strong>%</strong>
                </th>
                <th width="10%">
                  <strong>{{'FIXED_VALUE'|translate}}</strong>
                </th>
                <th width="10%">
                  <strong>{{'DEBIT_CREDIT'|translate}}</strong>
                </th>
                <th width="15%">
                  <strong>{{'INCIDENCE'|translate}}</strong>
                </th>
                <th *ngIf="!isDisabled" width="5%"></th>
              </tr>
            </thead>
            <tbody formArrayName="CostCenterConfigList">
              <ng-container *ngIf="form.controls.CostCenterConfigList.controls.length > 0; else noResultsCostCenterConfig">
                <tr *ngFor="let item of form.controls.CostCenterConfigList.controls; let i=index" [formGroupName]="i">
                  <td>
                    <mat-form-field class="allwidth">
                      <mat-select formControlName="Type" (selectionChange)="onChange($event.value, i)">
                        <mat-option *ngFor="let type of typeList" [value]="type.ItemCode">{{type.ItemName}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td>
                    <!-- Se tipo selecionado for : centro de custo -->
                    <mat-form-field *ngIf="form.controls.CostCenterConfigList.controls[i].controls.Type.value === 'CostCenter'"
                      class="col-md-7 no-padding-left">
                      <mat-select formControlName="AnalisysAxeID" (selectionChange)="onSelectAnalysysAxe($event.value, i)"
                        [ngClass]="{ 'mat-input-invalid': !form.controls.CostCenterConfigList.controls[i].controls.CostCenterID.valid}">
                        <mat-option value=''></mat-option>
                        <mat-option *ngFor="let item of analisysAxesList" [value]="item.ID">{{item.Name}}</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field *ngIf="form.controls.CostCenterConfigList.controls[i].controls.Type.value === 'CostCenter'"
                      class="col-md-5 no-padding-left" [ngClass]="{ 'mat-input-invalid': !form.controls.CostCenterConfigList.controls[i].controls.CostCenterName.valid}">
                      <input matInput class="one" formControlName="CostCenterName">
                        <i matSuffix class="glyphicon glyphicon-new-window" style="font-size: 13px" (click)="selectCostCenter(i)" *ngIf="!form.controls.CostCenterConfigList.controls[i].controls.IsCostCenterFreeText.value && !isDisabled"></i>
                    </mat-form-field>

                    <!-- Se tipo selecionado for : chave de repartição -->
                    <mat-form-field *ngIf="form.controls.CostCenterConfigList.controls[i].controls.Type.value === 'DivisionKey'"
                      class="allwidth">
                      <mat-select formControlName="DivisionKeyID" [ngClass]="{ 'mat-input-invalid': !form.controls.CostCenterConfigList.controls[i].controls.CostCenterID.valid}">
                        <mat-option value=''></mat-option>
                        <mat-option *ngFor="let item of divisionKeysList" [value]="item.ID">{{item.Name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <!-- Percentagem -->
                  <td>
                    <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': !form.controls.CostCenterConfigList.controls[i].controls.Percentage.errors }">
                      <input matInput formControlName="Percentage" (change)="onChangePercentage($event.target.value, i)"
                        class="no-padding-left">
                    </mat-form-field>
                  </td>
                  <!-- Valor Fixo -->
                  <td>
                    <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': !form.controls.CostCenterConfigList.controls[i].controls.FixedValue.errors }">
                      <input matInput formControlName="FixedValue" (change)="onChangeFixedValue($event.target.value, i)"
                        class="no-padding-left">
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field class="allwidth">
                      <mat-select formControlName="DebitOrCredit" [ngClass]="{ 'mat-input-invalid': !form.controls.CostCenterConfigList.controls[i].controls.DebitOrCredit.erros}">
                        <mat-option *ngFor="let debCred of debitCreditList" [value]="debCred.ItemCode=='C'">{{debCred.ItemName}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field class="allwidth">
                      <mat-select formControlName="Incidence" [ngClass]="{ 'mat-input-invalid': !form.controls.CostCenterConfigList.controls[i].controls.Incidence.valid}">
                        <mat-option *ngFor="let incid of incidenceList" [value]="incid.ItemCode">{{incid.ItemName}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td *ngIf="!isDisabled" class="text-center">
                    <button type="button" class="btn btn-sm" (click)="remove(i)">
                      <span title="{{'BUTTON.DELETE' | translate}}">
                        <i class="far fa-trash-alt color-danger backwhite"></i>
                      </span>
                    </button>

                    <button type="button" class="btn btn-sm" (click)="copy(item)">
                      <span title="{{'COPY' | translate}}">
                        <i class="far fa-clone blue backwhite"></i>
                      </span>
                    </button>
                  </td>
                </tr>
              </ng-container>
              <ng-template  #noResultsCostCenterConfig>
                <tr>
                  <td [colSpan]="!isDisabled ? 7 : 6" class="text-center">{{ 'NO_RESULTS_WERE_FOUND' | translate }}</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div mat-dialog-actions>
      <div class="full-width text-right modal-theme">
        <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}" (click)="dialogRef.close(null)">
          {{'BUTTON.CANCEL' | translate}}
        </button>
        <button *ngIf="!isDisabled" type="button" class="btn btn-default" title="{{'RECALCULATE' | translate}}" (click)="recalculate()">
          {{'RECALCULATE' | translate}}
        </button>
        <button *ngIf="!isDisabled" type="button" class="btn btn-default" title="{{'ADD' | translate}}" (click)="addCostCenterConfig(true)">
          {{'ADD' | translate}}
        </button>
        <button *ngIf="!isDisabled" type="button" class="btn btn-primary" title="{{'BUTTON.SAVE' | translate}}" (click)="onSubmit()">
          {{'BUTTON.SAVE' | translate}}
        </button>
      </div>
    </div>
  </form>
</div>